var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "popstyle",
        staticStyle: { "z-index": "99" },
        style: { display: _vm.parsedLocalizado }
      },
      [
        _c(
          "b-modal",
          {
            ref: "ListModal",
            staticClass: "fixedModal",
            attrs: { size: "lg", centered: "", "hide-footer": true },
            on: { hidden: _vm.onHidden }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.hideList,
                    expression: "!hideList"
                  }
                ]
              },
              [
                _c("v-server-table", {
                  ref: "table",
                  staticClass: "custom",
                  attrs: {
                    columns: _vm.columns,
                    url: _vm.url,
                    options: _vm.options
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "id_comercial",
                      fn: function(props) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.row.id_comercial.id) +
                              "\n          "
                          )
                        ])
                      }
                    },
                    {
                      key: "id_caldera",
                      fn: function(props) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.row.id_caldera.id) +
                              "\n          "
                          )
                        ])
                      }
                    },
                    {
                      key: "nombre",
                      fn: function(props) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.row.id_comercial.nombre) +
                              "\n          "
                          )
                        ])
                      }
                    },
                    {
                      key: "dirección",
                      fn: function(props) {
                        return _c("div", {}, [
                          props.row["id_" + _vm.type].tipo_via &&
                          props.row["id_" + _vm.type].nombre_via &&
                          props.row["id_" + _vm.type].numero
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      props.row["id_" + _vm.type].tipo_via
                                    ) +
                                    "\n              " +
                                    _vm._s(
                                      props.row["id_" + _vm.type].nombre_via
                                    ) +
                                    ",\n              " +
                                    _vm._s(props.row["id_" + _vm.type].numero) +
                                    "\n              " +
                                    _vm._s(props.row["id_" + _vm.type].anexo) +
                                    ",\n              " +
                                    _vm._s(
                                      props.row["id_" + _vm.type].poblacion
                                    ) +
                                    ",\n              " +
                                    _vm._s(
                                      props.row["id_" + _vm.type].municipio
                                    ) +
                                    ",\n              " +
                                    _vm._s(
                                      props.row["id_" + _vm.type].provincia
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      props.row["id_" + _vm.type]
                                        .direccion_no_estructurada
                                    ) +
                                    "\n            "
                                )
                              ])
                        ])
                      }
                    },
                    {
                      key: "status",
                      fn: function(props) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.status.find(function(e) {
                                  return (
                                    e.id ===
                                    props.row.id_comercial
                                      .id_status_gestion_comercial
                                  )
                                }).status
                              ) +
                              "\n          "
                          )
                        ])
                      }
                    },
                    {
                      key: "visitado",
                      fn: function(props) {
                        return _c("div", {}, [
                          props.row["id_" + _vm.type].visitas.length > 0
                            ? _c("span", [_vm._v("Si")])
                            : _c("span", [_vm._v("No")])
                        ])
                      }
                    },
                    {
                      key: "visitado_usuario",
                      fn: function(props) {
                        return _c("div", {}, [
                          props.row["id_" + _vm.type].visitas.filter(function(
                            e
                          ) {
                            return e.codigo_visitador === _vm.user
                          }).length > 0
                            ? _c("span", [_vm._v("Si")])
                            : _c("span", [_vm._v("No")])
                        ])
                      }
                    },
                    {
                      key: "acciones",
                      fn: function(props) {
                        return _c(
                          "div",
                          {},
                          [
                            _c(
                              "b-btn",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.openDetails(props.row)
                                  }
                                }
                              },
                              [_vm._v("Ir")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-btn",
                              {
                                attrs: {
                                  variant: "danger",
                                  disabled: _vm.show_only
                                },
                                on: {
                                  click: function($event) {
                                    _vm.removeFromLote(props.row)
                                  }
                                }
                              },
                              [_vm._v("Eliminar")]
                            )
                          ],
                          1
                        )
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.hideList
              ? _c("div", [
                  _c(
                    "div",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-btn", { on: { click: _vm.close } }, [
                                _vm._v("Atras")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c("b-btn", { on: { click: _vm.localizar } }, [
                                _vm._v("Localizar")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("Details", {
                        ref: "details",
                        attrs: { feature: _vm.feature, permisos: _vm.permisos },
                        on: {
                          close: _vm.close,
                          comercialSaved: _vm.comercialSaved,
                          calderaSaved: _vm.calderaSaved
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.localizado
      ? _c(
          "div",
          { staticClass: "bottomButton" },
          [_c("b-button", { on: { click: _vm.atras } }, [_vm._v("Atras")])],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/LotesListSolapados.vue?vue&type=template&id=3dce6f3e&
// module id = null
// module chunks = 